export const APPLICATION_BOOTSTRAP_LOADED_EVENT = 'countercyclical:application-bootstrap-loaded';

const ASSET_RECOVERY_STORAGE_KEY = 'countercyclical:asset-recovery-attempt';
const ASSET_RECOVERY_QUERY_PARAMETER = '__cc_asset_retry';
const ASSET_RECOVERY_COOLDOWN_MS = 5 * 60 * 1000;

export const createAssetRecoveryScriptSource = () =>
    `
(() => {
    const applicationLoadedEvent = ${JSON.stringify(APPLICATION_BOOTSTRAP_LOADED_EVENT)};
    const cooldownMs = ${ASSET_RECOVERY_COOLDOWN_MS};
    const queryParameter = ${JSON.stringify(ASSET_RECOVERY_QUERY_PARAMETER)};
    const storageKey = ${JSON.stringify(ASSET_RECOVERY_STORAGE_KEY)};

    const isApplicationAsset = (value) => {
        if (!value) return false;

        try {
            const url = new URL(value, window.location.href);
            return url.origin === window.location.origin && /^\\/assets\\/.*\\.(?:css|js)$/.test(url.pathname);
        } catch {
            return false;
        }
    };

    const readLastAttempt = () => {
        try {
            return Number.parseInt(window.sessionStorage.getItem(storageKey) ?? '', 10) || 0;
        } catch {
            return 0;
        }
    };

    const rememberAttempt = (timestamp) => {
        try {
            window.sessionStorage.setItem(storageKey, String(timestamp));
        } catch {
            // Recovery can still proceed when storage is blocked by browser policy.
        }
    };

    const recoverFromStaleAssets = () => {
        const now = Date.now();
        const recoveryUrl = new URL(window.location.href);
        const queryAttempt =
            Number.parseInt(recoveryUrl.searchParams.get(queryParameter) ?? '', 10) || 0;
        const lastAttempt = Math.max(readLastAttempt(), queryAttempt);

        if (now - lastAttempt < cooldownMs) return;

        rememberAttempt(now);
        recoveryUrl.searchParams.set(queryParameter, String(now));
        window.location.replace(recoveryUrl.toString());
    };

    window.addEventListener(
        'error',
        (event) => {
            const target = event.target;
            const assetUrl =
                target instanceof HTMLScriptElement
                    ? target.src
                    : target instanceof HTMLLinkElement
                      ? target.href
                      : undefined;

            if (isApplicationAsset(assetUrl)) recoverFromStaleAssets();
        },
        true,
    );

    window.addEventListener('vite:preloadError', (event) => {
        event.preventDefault();
        recoverFromStaleAssets();
    });

    window.addEventListener(
        applicationLoadedEvent,
        () => {
            const currentUrl = new URL(window.location.href);
            if (!currentUrl.searchParams.has(queryParameter)) return;

            currentUrl.searchParams.delete(queryParameter);
            window.history.replaceState(
                window.history.state,
                '',
                currentUrl.pathname + currentUrl.search + currentUrl.hash,
            );
        },
        { once: true },
    );
})();
`.trim();

export const notifyApplicationBootstrapLoaded = () => {
    window.dispatchEvent(new Event(APPLICATION_BOOTSTRAP_LOADED_EVENT));
};
